import { render, staticRenderFns } from "./categoryMaintenance.vue?vue&type=template&id=fd59df12&scoped=true&"
import script from "./categoryMaintenance.vue?vue&type=script&lang=js&"
export * from "./categoryMaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd59df12",
  null
  
)

component.options.__file = "categoryMaintenance.vue"
export default component.exports